import { render, staticRenderFns } from "./WorkshopsList.vue?vue&type=template&id=b493d564&scoped=true&"
import script from "./WorkshopsList.vue?vue&type=script&lang=js&"
export * from "./WorkshopsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsList.vue?vue&type=style&index=0&id=b493d564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b493d564",
  null
  
)

export default component.exports